var map = {
	".": "8e1X",
	"./": "8e1X",
	"./01_get_account_apiRestrictions": "l5cf",
	"./01_get_account_apiRestrictions.json": "l5cf",
	"./index": "8e1X",
	"./index.js": "8e1X"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "I/UF";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/common/api/permission ^.*$
// module id = I/UF
// module chunks = 3